import React from 'react';

import DonutFiguresCard from '~support-at-home/components/common/DonutFiguresCard';
import SectionInfo from '~support-at-home/components/common/SectionInfo';

import { DASHBOARD_TEXT } from './dashboardText';
import { DashboardWidgetStatus, READY_WIDGET } from './dashboardWidgets';
import { DashboardWidgetState } from './DashboardWidgetState';
import { OverviewView } from './utils';

interface ComponentProps {
  /** Null until the figures it needs have arrived. */
  view: OverviewView | null;
  /** Loading or failed: the state box replaces the ring and figures, under the title. Default ready. */
  status?: DashboardWidgetStatus;
}

const copy = DASHBOARD_TEXT.overview;

/**
 * Company Budget Overview (TAV-3343, restyled TAV-3442, TAV-3463): the Budget Tracker's Budget Overview over every
 * included budget. The ring fills with the total Booked and Claimed against the total Allocated; only when that total
 * is over does the rest run on as a second amber ring and the card's outline turn amber (TAV-3482).
 */
export const CompanyBudgetOverview: React.FC<ComponentProps> = ({ view, status = READY_WIDGET }) => (
  <DonutFiguresCard
    title={copy.title}
    description={copy.description}
    titleAddon={<SectionInfo id="dashboard-overview-section" label={copy.title} content={copy.section} />}
    className="company-budget-overview"
    over={view?.over}
    dataCy="dashboard-company-budget-overview"
    donut={view?.donut}
    legend={view?.legend}
    pending={
      status.phase !== 'ready' || !view ? (
        <DashboardWidgetState status={status} title={copy.title} dataCy="dashboard-company-budget-overview" />
      ) : undefined
    }
    emptyLabel={copy.empty}
    emptyDataCy="dashboard-company-budget-overview-empty"
  />
);
